import type { FeatureFlagKey } from "@repo/app-types/featureFlags/keys";
import { useSelector } from "react-redux";
import type { RootState } from "../../app/store.js";

// Reads the /boot snapshot held in the Redux `featureFlags` slice. There is no
// live flag channel: a change lands whenever the boot query refetches (mount,
// reconnect, or window focus once the snapshot is stale — see
// BOOT_STALE_TIME_MS), and a page reload always picks it up immediately.
export function useIsFeatureFlagEnabled(key: FeatureFlagKey): boolean {
  return useSelector((state: RootState) => state.featureFlags.includes(key));
}
